import { CDN_PIVOT } from 'core/constants/endpoints'
import getById from 'utils/DOM/getById'
import toggleClass from 'utils/DOM/toggleClass'
import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import quotesTourStore from './quotesTourStore'
export interface Step {
  title: string
  element: string
  intro: string
}

function loadQuotesTour() {
  fetchJSONHandleError({
    url: `${CDN_PIVOT}/resources/quotes-tour/quotesTour.json`
  }).then(newSteps => {
    quotesTourStore.update({ tourSteps: newSteps })
  })
}

function closeTour() {
  toggleClass(getById('intro-wrapper'), 'fadeOutDown', true)
}

function startTour() {
  const steps = quotesTourStore.getState().tourSteps
  if (steps) {
    setTimeout(() => {
      window
        .introJs()
        .setOptions({
          steps: steps.map(step => ({
            ...step,
            selector: document.querySelector(step.element)
          }))
        })
        .start()
      toggleClass(getById('intro-wrapper'), 'fadeOutDown', true)
    }, 300)
  }
}
export { closeTour, startTour, loadQuotesTour }
